/* Skyteck UX enhancements (design phase) */
(function () {
  // Collection: add a "Read more" toggle to the clamped SEO intro on mobile
  function collectionReadMore() {
    if (!/\/collections\//.test(location.pathname)) return;
    var d = document.querySelector('.collection-hero__description');
    if (!d || d.dataset.skReadmore) return;
    if (d.scrollHeight <= d.clientHeight + 8) return; // not overflowing at this width
    d.dataset.skReadmore = '1';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sk-readmore';
    btn.textContent = 'Read more';
    btn.addEventListener('click', function () {
      var expanded = d.classList.toggle('sk-expanded');
      btn.textContent = expanded ? 'Read less' : 'Read more';
    });
    d.insertAdjacentElement('afterend', btn);
  }

  // PDP mobile: keep the chat launcher clear of the sticky add-to-cart bar.
  // The launcher script injects late and its host ids vary, so match broadly
  // and re-apply whenever body children change.
  function chatVsStickyAtc() {
    if (!document.getElementById('sk-sticky-atc')) return;
    var SEL = '#shopify-chat, #ShopifyChat, #dummy-chat-button-iframe, [id^="shopify-chat"]:not(script), iframe[title*="chat" i]';
    function apply() {
      var mobile = window.innerWidth <= 749;
      document.querySelectorAll(SEL).forEach(function (el) {
        if (el.tagName === 'SCRIPT') return;
        if (mobile) {
          el.style.setProperty('bottom', '84px', 'important');
          el.dataset.skRaised = '1';
        } else if (el.dataset.skRaised) {
          el.style.removeProperty('bottom');
          delete el.dataset.skRaised;
        }
      });
    }
    apply();
    try { new MutationObserver(apply).observe(document.body, { childList: true }); } catch (e) { /* no-op */ }
    window.addEventListener('resize', apply);
  }

  // Perth notice block: hide for visitors whose saved estimator postcode is
  // outside WA (postcodes 6xxx); WA visitors and unknown visitors still see it.
  function perthNoticeGate() {
    var pc = '';
    try { pc = localStorage.getItem('sk_postcode') || ''; } catch (e) { /* private mode */ }
    if (!pc || /^6\d{3}$/.test(pc)) return;
    var headings = document.querySelectorAll('h1,h2,h3,h4');
    for (var i = 0; i < headings.length; i++) {
      if (/Perth Customers Notice/i.test(headings[i].textContent)) {
        var box = headings[i].closest('div');
        if (box) box.style.display = 'none';
        return;
      }
    }
  }

  function init() {
    collectionReadMore();
    chatVsStickyAtc();
    perthNoticeGate();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
